/* 
 * AMD loader for the google api 
 */
import globals = require("../globals");

const cbkey = "__define__googlemaps";

const defaults = {
    url: globals["GoogleMapsUrl"] || "//maps.googleapis.com/maps/api/js?v=3.25",
    key: globals["GoogleMapsKey"]
};

let loader = {
    about: `google API loader plugin`,
    tester: function () {
        return (window["google"] && google.maps && typeof google.maps.Map !== "undefined");
    },
    load: function (param, req, done) {
        param = JSON.parse(param);

        if (loader.tester()) {
            done(google);
            return;
        }

        let url = `${param.url || defaults.url}&key=${param.key || defaults.key}&callback=${cbkey}`;

        window[cbkey] = function () {
            let h = setInterval(() => {
                if (loader.tester()) {
                    clearInterval(h);
                    done(google);
                    delete window[cbkey];
                    return;
                }
                console.log("waiting for google maps to load");
            });
        };

        requirejs([url]);
    }
};

export = loader;

